import moment from 'moment';

export const startDate = moment().add(-30, 'days').format('YYYY-MM-DD');
export const endDate = moment().format('YYYY-MM-DD');
